import assets from "../helpers/assets"

const light = {
    name: 'light',
    dashboard: {
        backgroundColor: "#FFFFFF",
        fontColor: "#000000",
        header: {
            fontColor: "#2a3146",
            borderColor: "#ededed",
            logoImage: assets.logoColor,
        },
        section: {
            titleColor: "#565c6c"
        },
        row: {
            fontColor: "#2a3146",
            backgroundColor: "#FFFFFF",
            borderColor: "#ededed",
            greenText: "#447610",
            yellowText: "#dfa61f",
        },
        footer: {
            lineColor: "#ececec",
            lineActiveColor: "#4bb3ef"
        },
        labels: {
            inHouse: assets.inhouse,
            unassigned: assets.blank,
            quiqup: assets.quiqup,
            hungerStation: assets.hungerStation,
            otlob: assets.otlob,
            talabat: assets.talabat,
            zomato: assets.zomato,
            deliveroo: assets.deliveroo,
            careembox: assets.careembox,
            careemnow: assets.careemnow,
            jahez: assets.jahez,
            jeebly: assets.jeebly,
            oneclick: assets.oneclick,
        }
    }
}

const dark = {
    name: 'dark',
    dashboard: {
        backgroundColor: "#1b1f2a",
        fontColor: "#ffffff",
        header: {
            fontColor: "#ffffff",
            borderColor: "#252a38",
            logoImage: assets.logoWhite,
        },
        section: {
            titleColor: "#565c6c"
        },
        row: {
            fontColor: "#ffffff",
            backgroundColor: "#232836",
            borderColor: "#232836",
            greenText: "#5c9520",
            yellowText: "#e8b232",
        },
        footer: {
            lineColor: "#232836",
            lineActiveColor: "#767f9b"
        },
        labels: {
            inHouse: assets.inhouseDark,
            unassigned: assets.blankDark,
            quiqup: assets.quiqupDark,
            hungerStation: assets.hungerStation,
            otlob: assets.otlobDark,
            talabat: assets.talabat,
            zomato: assets.zomato,
            deliveroo: assets.deliveroo,
            careembox: assets.careembox,
            careemnow: assets.careemnow,
            jahez: assets.jahez,
            jeebly: assets.jeebly,
            oneclick: assets.oneclick,
        }
    }
}

export default {
    'light': light,
    'dark': dark
}
